import { STATUS } from "@/lib/constants";

export default function StatusBadge({ status, className = "" }) {
  const s = STATUS[status] || STATUS.SOB_CONSULTA;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center border px-2.5 py-1 text-[0.7rem] font-bold uppercase tracking-wider ${s.cls} ${className}`}
    >
      {s.label}
    </span>
  );
}
